import { render, staticRenderFns } from "./InterventionPublish.vue?vue&type=template&id=1bd38b46"
import script from "./InterventionPublish.vue?vue&type=script&lang=js"
export * from "./InterventionPublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports